<template>
  <div>
    <list-template
      :search-config="searchConfig"
      :table-config="tableConfig"
      :table-data="tableData"
      :total="total"
      :loading="loading"
      :current-page="page"
      @onAdd="handleAdd"
      @onHandle="handleClick"
      @onExportData="handDownload"
      @onSearch="onSearch"
      @onReset="onReset"
      @onChangePage="handleCurrentChange"
      @onChange="onChange"
    />
    <Dialog :visible.sync="visible" showLine title="操作记录" :showFooter="false">
      <TimeLine :list="list" reverse v-loading="dialogLoading"></TimeLine>
    </Dialog>
  </div>
</template>

<script>
import Dialog from '@/components/common/Dialog'
import TimeLine from '@/components/common/TimeLine'
import { tableListMixin } from '@/utils/mixins'
import { setConfigOption } from '@/utils'
import http, { fileDownload, zh_opt_history, changeObjToArr } from '@/api'
export default {
  _config:{'route':{'path':'list','meta':{'title':'列表','keepAlive':true}}},
  mixins: [tableListMixin],
  components: { Dialog, TimeLine },
  data() {
    return {
      visible: false,
      dialogLoading: false,
      list: [],
      options: [],
      searchConfig: [
        { placeholder: '搜索教材名称', prop: 'teach_name' },
        { placeholder: '筛选学段', prop: 'apply_type', tag: 'select', options: [], change: (val, search) => {
          if (search.teach_grade) search.teach_grade = ''
          const arr = changeObjToArr(this.options[val])
          setConfigOption({ list: this.searchConfig, data: arr, key: 'teach_grade' })
        } },
        { placeholder: '筛选科目', prop: 'subject_id', tag: 'select', options: [] },
        { placeholder: '筛选教学年级', prop: 'teach_grade', tag: 'select', options: [] }
      ],
      tableConfig: [
        { prop: 'teach_name', width: '480rem', label: '教材名称' },
        { prop: 'apply_type_name', label: '学段' },
        { prop: 'subject_name', label: '科目' },
        { prop: 'teach_grade', label: '教学年级', render: ({teach_grade}) => teach_grade.join(',') },
        { prop: 'creator', label: '创建人' },
        { label: '操作', width: '200rem', handle: true }
      ]
    }
  },
  created() {
    this.getConfig()
  },
  methods: {
    onReset() {
      setConfigOption({ list: this.searchConfig , data: [], key: 'teach_grade' })
    },
    getConfig() {
      http({ url: '/time-course/get-conf', pre: 'zh' }).then(res => {
        const { apply_type = [], subject_id = [], teach_grade = [] } = res
        setConfigOption({ list: this.searchConfig, data: apply_type, key: 'apply_type', value: 'id', label: 'apply_name' })
        setConfigOption({ list: this.searchConfig, data: subject_id, key: 'subject_id', value: 'id', label: 'subject_name' })
        this.options = teach_grade
      })
    },
    getData() {
      this.getDataApi('/wisdom-education/time-course/list')
    },
    getHistory(id) {
      this.list = []
      this.dialogLoading = true
      zh_opt_history({ type: 'time_course_basic', id }).then(res => {
        const { list } = res
        this.list = list.map(i => ({ content: i.change_detail }))
      }).finally(() => this.dialogLoading = false)
    },
    handDownload() {
      fileDownload('/xxx', {...this.search}, { name: 'yyy', show: true })
    },
    handleAdd() {
      this.$router.push('./add')
    },
    handleClick(row, handle) {
      const { type } = handle
      if (type === 'view') {
        this.$router.push({ path: `./detail/?id=${row.id}` })
      } else if (type === 'edit') {
        this.$router.push({ path: `./edit/?id=${row.id}` })
      } else if (type === 'viewHistory') {
        this.getHistory(row.id)
        this.visible = true
      }
    }
  }
}
</script>

<style lang="scss" scoped></style>
